import React from 'react';
import { Box, Paper } from '@mui/material';
import colors from '../../../assets/theme/colors';
import UnifiedTimeline from '../../Timeline/UnifiedTimeline';

const MobileTimelinePanel = React.forwardRef(({
  child,
  selectedDate,
  filters,
  onFiltersChange,
  focusEntryId,
  calendarEntries,
  onDateChange,
  onOpenDatePicker,
  onOpenPatterns,
  onAddEntryForDate,
  onReviewAppointment,
}, ref) => {
  return (
    <Paper
      ref={ref}
      elevation={0}
      sx={{
        borderRadius: 0,
        border: 'none',
        boxShadow: 'none',
        overflow: 'hidden',
        backgroundColor: colors.landing.surface,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        mb: 0,
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', px: 0, py: 0, background: `linear-gradient(180deg, ${colors.landing.surface} 0%, ${colors.semantic.sageMist} 100%)` }}>
        <UnifiedTimeline
          child={child}
          selectedDate={selectedDate}
          filters={filters}
          onFiltersChange={onFiltersChange}
          showFilters={false}
          showDaySummary={true}
          mobileTimeLayout={true}
          focusEntryId={focusEntryId}
          calendarEntries={calendarEntries}
          onDateChange={onDateChange}
          onOpenDatePicker={onOpenDatePicker}
          onOpenPatterns={onOpenPatterns}
          onAddEntryForDate={onAddEntryForDate}
          onReviewAppointment={onReviewAppointment}
          showSourceActivity={false}
        />
      </Box>
    </Paper>
  );
});

MobileTimelinePanel.displayName = 'MobileTimelinePanel';

export default MobileTimelinePanel;
